import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import ConversationList from "../components/agent/ConversationList";
import ConversationThread from "../components/agent/ConversationThread";

export default function AgentConversations() {
  const [params, setParams] = useSearchParams();
  const [selectedId, setSelectedId] = useState(params.get("session") || null);

  useEffect(() => {
    if (selectedId) setParams({ session: selectedId });
    else setParams({});
  }, [selectedId]);

  return (
    <div className="flex h-[calc(100vh-4rem)] bg-gray-50">
      <div className="w-2/5 border-r border-gray-200 bg-white flex flex-col overflow-hidden">
        <ConversationList selectedId={selectedId} onSelect={setSelectedId} />
      </div>
      <div className="flex-1 flex flex-col overflow-hidden">
        <ConversationThread sessionId={selectedId} onSessionChange={setSelectedId} />
      </div>
    </div>
  );
}
